import React, { useCallback, useEffect, useState } from 'react';
import { ReloadOutlined, SearchOutlined } from '@ant-design/icons';
import { Button, Input, Space, Table, Typography } from 'antd';
import { apiClient, apiErrorMessage } from '../../../utils';
import { Filter } from '../../../models';

export function FilterUsagesPage(props: { filter?: Filter }) {
  const [loading, setLoading] = useState(false);
  const [usages, setUsages] = useState<any[]>();
  const [searchText, setSearchText] = useState('');

  const { Text } = Typography;

  const loadUsages = useCallback(async () => {
    setLoading(true);
    apiClient
      .get(`filters/${props.filter?.id}/usages`)
      .then(response => {
        setUsages(response.data);
      })
      .catch((reason: any) => {
        apiErrorMessage(reason);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [props.filter?.id]);

  useEffect(() => {
    loadUsages();
  }, [loadUsages]);

  const onRefreshClick = () => {
    loadUsages();
  };

  const tableColumns = [
    {
      title: 'Tür',
      dataIndex: 'objectTypeLabel',
      key: 'objectTypeLabel',
    },
    {
      title: 'İsim',
      dataIndex: 'objectName',
      key: 'objectName',
      render: (objectName: string, usage: any) => (
        <Space direction="vertical">
          <Text strong>{objectName}</Text>
          <Text>{usage.objectDescription}</Text>
        </Space>
      ),
    },
  ];

  const filteredUsages = usages?.filter(
    usage =>
      usage.objectTypeLabel.toLowerCase().includes(searchText.toLowerCase()) ||
      usage.objectName.toLowerCase().includes(searchText.toLowerCase()) ||
      usage.objectDescription.toLowerCase().includes(searchText.toLowerCase()),
  );

  return (
    <div>
      <Space style={{ width: '100%', justifyContent: 'flex-end', marginBottom: '2rem', textAlign: 'right' }}>
        <div>
          <Input
            placeholder="Arama"
            prefix={<SearchOutlined />}
            onChange={e => setSearchText(e.target.value)}
            style={{ width: 250 }}
            allowClear
          />
        </div>
        <Button key="refresh" onClick={onRefreshClick} icon={<ReloadOutlined />}>
          Yenile
        </Button>
      </Space>

      <Table
        columns={tableColumns}
        dataSource={filteredUsages}
        loading={loading}
        scroll={{ x: '100%' }}
        pagination={false}
        rowKey="objectId"
      />
    </div>
  );
}
